

export const download_links = {
    windows: "https://api.stacher.io/api/update/windows/x64/latest",
    macsilicon: "https://api.stacher.io/api/update/mac/arm64/latest",
    macintel: "https://api.stacher.io/api/update/mac/x64/latest",
    linux: "https://api.stacher.io/api/update/linux/x64/latest",
}

export const setup_names = {
    windows: "stacher-VERSION-setup.exe",
    macsilicon: "Stacher_Setup_VERSION_arm64.dmg",
    macintel: "Stacher_Setup_VERSION_x64.dmg",
    linux: "stacher7_VERSION_amd64.deb",
}